import React from "react";
import { List, Datagrid, TextField, DateField, FunctionField, SearchInput, SelectInput, useResourceContext, TopToolbar, ExportButton } from "react-admin";
import { Link } from "react-router-dom";
import { formatPostalCode, getNameAndCompanyName, isOverdue, monthChoices } from "../common";
import { downloadCSV } from 'react-admin';
import { unparse } from 'papaparse';
import CustomCreateButton from "../components/CustomeCreateButton";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ConstructHistoryList = () => {
  const resource = useResourceContext();
  const CustomerFilters = [
    <SearchInput
      source="q"
      alwaysOn
      placeholder="郵便番号・住所・顧客名"
      inputProps={{ style: { fontSize: '12px' } }}
      sx={{ width: 250 }}
    />,
    <SearchInput
      source="content"
      alwaysOn
      placeholder="修理内容"
      inputProps={{ style: { fontSize: '12px' } }}
    />,
    <SelectInput
      source="month"
      label={<span style={{ fontSize: "12px" }}>修理月</span>}
      choices={monthChoices}
      alwaysOn
      sx={{
        ".MuiInputBase-root": { height: "35px" },
        ".MuiInputBase-input": {
          fontSize: "12px"
        },
      }}
    />
  ];

  // const customExporter = (records) => {
  //   // エクスポートするデータをカスタムフォーマットに変換
  //   const csvData = records.map(record => {

  //     return {
  //       // "修理No": String(record.number).padStart(5, "0"), 
  //       "修理日": record.constructDate ? new Date(record.constructDate).toLocaleDateString() : "",
  //       "住所": `${record.postCode ? record.postCode : ""} ${record.address ?? ""}`, 
  //       "顧客名":`${getNameAndCompanyName(record.surname,record.name,record.companyName)}`, // フルネーム結合
  //       "請求日": record.invoiceDate ? new Date(record.invoiceDate).toLocaleDateString() : "",
  //       "再発行日": record.reissueDate ? new Date(record.reissueDate).toLocaleDateString() : "",
  //       "領収": record.isPay ? "済" : "",
  //       "領収日": record.receiptDate ? new Date(record.receiptDate).toLocaleDateString() : "",
  //       "担当者": record.staffName ?? "",
  //     }

  //   });

  //   // CSV のエクスポート
  //   const csv = "\uFEFF" + unparse(csvData, { header: true });
  //   downloadCSV(csv, `修理履歴_` + new Date().toLocaleDateString());
  // };


  const customExporter = (records) => {
    const excelData = records.map(record => {
      return {
        "修理日": record.constructDate ? new Date(record.constructDate).toLocaleDateString() : "",
        "住所": `${record.postCode ? record.postCode : ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`,
        "顧客名": `${record.bukken ?? ""}`,
        "請求日": record.invoiceDate ? new Date(record.invoiceDate).toLocaleDateString() : "",
        "再発行日": record.reissueDate ? new Date(record.reissueDate).toLocaleDateString() : "",
        "領収": record.isPay ? "済" : "",
        "領収日": record.receiptDate ? new Date(record.receiptDate).toLocaleDateString() : "",
        "担当者": record.staffName ?? "",
      };
    });

    // ワークシートを作成
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // ✅ 列幅を設定（文字数に応じて調整）
    worksheet['!cols'] = [
      { wch: 12 },  // 修理日
      { wch: 60 },  // 住所
      { wch: 25 },  // 顧客名
      { wch: 12 },  // 請求日
      { wch: 12 },  // 再発行日
      { wch: 8 },   // 領収
      { wch: 12 },  // 領収日
      { wch: 16 },  // 担当者
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "修理履歴");

    // バイナリデータを生成
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(blob, `修理履歴_${new Date().toLocaleDateString()}.xlsx`);
  }


  const handleRowClick = (id, basePath, record) => {
    const url = `${window.location.origin}/#/${basePath}/show/${id}`;
    const features = 'width=1200,height=800,left=200,top=100,noopener,noreferrer';
    window.open(url, '_blank', features);
    return false;
  };

  const CustomersActions = () => (
    <TopToolbar>
      <CustomCreateButton basePath="/constructHistory" />
      <ExportButton exporter={customExporter} />
    </TopToolbar>
  );

  return (
    <List filters={CustomerFilters} actions={<CustomersActions />}>
      <Datagrid rowClick={(id, basePath, record) => handleRowClick(id, basePath, record)} bulkActionButtons={false} rowStyle={(record) => isOverdue(record) ? { backgroundColor: "#FFCCCC" } : {}}>
        {/* <FunctionField source="number" label="修理No" render={(record) => {
          return String(record.number).padStart(5, "0");
        }}/> */}
        <DateField source="constructDate" label="修理日" />
        <FunctionField
          label="住所"
          render={record => {
            return `${record.postCode ? record.postCode : ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`;
          }}
        />
        <FunctionField label="顧客名"
          render={(record) => {
            return <Link to={`/customers-construct/show/${record.customerId}`}>{`${record.bukken ?? ""}`}</Link>;
          }}
          onClick={(e) => e.stopPropagation()}
        />
        <FunctionField
          label=""
          render={record => {
            // return <Link to={`/invoiceHistory/show/${record.invoiceId}`}>{record.invoiceNumber && String(record.invoiceNumber).padStart(5, "0")}</Link>;
            return <Link to={`/invoiceHistory/show/${record.invoiceId}`}>{record.invoiceNumber && <>請求</>}</Link>;
          }}
          onClick={(e) => e.stopPropagation()}
        />
        <DateField source="invoiceDate" label="請求日" />
        <DateField source="reissueDate" label="再発行日" />
        <FunctionField
          label="領収"
          render={record => {
            return `${record.isPay ? "済" : ""}`;
          }}
        />
        <DateField source="receiptDate" label="領収日" />
        <TextField source="staffName" label="担当者" />
      </Datagrid>
    </List>
  );
}

export default ConstructHistoryList;
